
export const pages = {
    main: "/",
    fullSchedule: "/schedule",
    settings: "/settings",
    fullScheduleLegacy: "/schedule.html",
    settingsLegacy: "/settings.html",
    selectSchool: "/select",
    loginCallback: "/admin/callback",
    welcome: "/welcome",
    admin: "/admin",
    adminBellSchedule: "/admin/bellschedule"
};

export const URLs = {
    github: "https://github.com/MoralCode/ClassClock",
    slack:
        "https://join.slack.com/t/classclock/shared_invite/enQtNTE0MDkyNzAwNzU3LWNhMGUwODU2ZjhkYTYxMTgzNDE1OWEyMGY2OGNiNTBhOWM5NDVhZGUzNDVlNzRiZTE3NTNmODFjYWNkNDhmMDU",
    twitter: "https://twitter.com/classclockapp",
    instagram: "https://www.instagram.com/classclockapp/",
    discord: "https://discord.classclock.app"
};
